module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 map-sidebar"
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "scroll-ajuste"
  }, [_vm._l((_vm.locationPoints), function(w, i) {
    return _c('input-ac', {
      key: w.address + w.sequence,
      attrs: {
        "initLocation": w,
        "sequence": i,
        "totalPoints": _vm.locationPoints.length
      },
      on: {
        "addPoint": _vm.addPoint,
        "removePoint": _vm.removePoint,
        "placeChanged": _vm.placeChanged
      }
    })
  }), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-error margin-t10"
  }, [_vm._v("\n          " + _vm._s(_vm.msgError) + "\n        ")]) : _vm._e()], 2), _vm._v(" "), (false) ? _c('div', [_c('label', {
    staticClass: "block-round-trip"
  }, [_vm._v("Ida e volta?")]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-axis"
  }, [_c('label', {
    staticClass: "block-round-trip"
  }, [_vm._v("Quantidade de eixos:")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-lg margin-t5",
    attrs: {
      "options": _vm.axesOp,
      "value": _vm.axes,
      "fieldValue": "category_artesp_id"
    },
    model: {
      value: (_vm.axes),
      callback: function($$v) {
        _vm.axes = $$v
      },
      expression: "axes"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-calculate",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("\n        Calcular\n      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showSummary) ? _c('div', {
    staticClass: "result-calculate-trip"
  }, [_c('ul', {
    staticClass: "trip-summary-box"
  }, [_c('li', [_c('i', {
    staticClass: "icon-road"
  }), _vm._v(" "), _c('label', {
    staticClass: "trip-summary-label"
  }, [_vm._v("Distância:")]), _vm._v(" "), _c('label', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.result.totalDistance) + " Km")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-clock"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('label', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("secondsFormat")(_vm.result.totalTime)))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-toll"
  }), _vm._v(" "), _c('label', {
    staticClass: "trip-summary-label"
  }, [_vm._v("Qtd. de Pedágios:")]), _vm._v(" "), _c('label', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.result.tolls.length))])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon-coin"
  }), _vm._v(" "), _c('label', {
    staticClass: "trip-summary-label"
  }, [_vm._v("Valor Pedágios:")]), _vm._v(" "), _c('label', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.result.totaltollFeeCost)))])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "bs-callout bs-callout-primary"
  }, [_vm._v("\n          Sua viagem irá custar "), _c('b', [_vm._v(_vm._s(_vm._f("cents")(_vm.result.totaltollFeeCost)))]), _vm._v(" em\n          pedágios. Deseja fazer uma recarga?\n        ")]) : _vm._e(), _vm._v(" "), (false) ? _c('button', {
    staticClass: "btn btn-success btn-recharge-fit"
  }, [_vm._v("\n          Recarregar "), _c('b', [_vm._v("R$ 50,00")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 map-area"
  }, [_c('div', {
    ref: "map",
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.image
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Viagem")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "margin-b20"
  }, [_vm._v("\n          Calcule a distância, o tempo estimado e o custo de pedágios da sua\n          viagem, para isso é só preencher os campos abaixo e clicar em\n          calcular:\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "onoffswitch"
  }, [_c('input', {
    staticClass: "onoffswitch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "round-switch"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "onoffswitch-label",
    attrs: {
      "for": "round-switch"
    }
  }, [_c('span', {
    staticClass: "onoffswitch-inner"
  }), _vm._v(" "), _c('span', {
    staticClass: "onoffswitch-switch"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "trip-summary-label"
  }, [_vm._v("\n              Tempo Estimado:\n              "), _c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "O tempo é estimado usando como base um veículo de passeio (2 eixos) na velocidade média das vias."
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-39e6ecfc!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/routing/routing.vue
// module id = 2101
// module chunks = 1